import _ from 'lodash';
import fp from 'lodash/fp';
import React from 'react';
import { wrapDisplayName } from 'recompose';
import { Alert } from '@deerplusofficial/pos-components';
import { withRouter, withClient } from '@deerplusofficial/pos-hoc';
import { createCancelToken } from '@deerplusofficial/pos-helper';

const timeFormat = 'YYYY-MM-DD HH:mm';

export default () => Component =>
  fp.compose(
    withClient(),
    withRouter()
  )(
    class extends React.Component {
      static displayName = wrapDisplayName(Component, 'WithPrintSummary');

      componentWillUnmount() {
        !_.isUndefined(this.cancelPrintSummary) && this.cancelPrintSummary();
      }

      onSummaryPrint = async ({ startDate, endDate }) => {
        const {
          channelId,
          client: { POSApi, onError },
        } = this.props;

        const { value: payload } = await Alert.fire({
          titleText: '確定要列印清帳條？',
          type: 'question',
          showCancelButton: true,
          showLoaderOnConfirm: true,
          preConfirm: async () => {
            try {
              return await POSApi.post(
                '/print/summary/',
                {
                  channel_id: channelId,
                  sale_start_time: startDate
                    .clone()
                    .utc()
                    .format(timeFormat),
                  sale_end_time: endDate
                    .clone()
                    .utc()
                    .format(timeFormat),
                },
                { cancelToken: createCancelToken(this.cancelPrintSummary) }
              );
            } catch (error) {
              return error;
            }
          },
        });

        if (!payload) return;

        fp.size(payload.data)
          ? Alert.fire({ title: '成功列印清帳條', type: 'success' })
          : onError(payload);
      };

      render() {
        return (
          <Component onSummaryPrint={this.onSummaryPrint} {...this.props} />
        );
      }
    }
  );



// WEBPACK FOOTER //
// ./src/model/Mutations/withPrintSummary.js